import EducationMasterList from "./EducationMasterList";

const AllEducation = () => (
  <EducationMasterList
    title="Education"
    addPath="/add-education"
    editPath="/edit-education"
    listEndpoint="/admin/all-education-fillter"
    deleteEndpoint="/admin/delete-education"
    responseKey="Education"
    includeCategory
  />
);

export default AllEducation;
